var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 667.261,
    height: 270.813,
    viewBox: "0 0 667.261 270.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67999",
    "data-name": "Group 67999",
    transform: "translate(-595 -609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48818",
    "data-name": "Group 48818",
    transform: "translate(595 609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65377",
    "data-name": "Path 65377",
    d: "M406.531,206.816c2.2-15.7-6.676-26.83-28.909-26.83H337.567l-11.146,79.3h21.2l3.423-24.34H364.1l12.771,24.34h24.492l-15.095-27.749c11.671-4.685,18.582-12.748,20.263-24.718m-21.556,1.753c-.88,6.261-6.038,9.99-13.81,9.99H353.342L356.2,198.2h17.562c6.794,0,12.295,2.656,11.211,10.368",
    transform: "translate(-123.415 -89.357)",
    fill: "#24226a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65378",
    "data-name": "Path 65378",
    d: "M410.184,179.985l-25.931,51.923L372.91,179.985H349.121l20.951,79.3h19.939l43.391-79.3Z",
    transform: "translate(-60.345 -89.36)",
    fill: "#24226a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65379",
    "data-name": "Path 65379",
    d: "M370.727,259.282h21.314l11.143-79.3h-21.31Z",
    transform: "translate(-0.317 -89.359)",
    fill: "#24226a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65380",
    "data-name": "Path 65380",
    d: "M328.387,196.478c7.685,0,14.513,2.5,21.159,7.111l12.65-14.04c-7.489-5.974-18.9-10.171-31.357-10.171-22.833,0-35.048,11.415-36.938,24.756-1.768,12.469,3.461,19.172,25.908,24.854,13.107,3.317,16.833,5.071,16.156,9.6-.593,3.982-5,7.02-14.483,7.02-10.085,0-16.988-2.566-24.851-8.875l-13.5,13.054c8.94,8.048,20.9,12.933,36.069,12.933,29.8,0,38.128-16.772,39.242-24.639,2.3-16.247-6.034-20.845-27.322-25.973-15.046-3.624-16.247-5.543-15.7-9.227.665-4.432,4.908-6.4,12.956-6.4",
    transform: "translate(-243.675 -91.049)",
    fill: "#24226a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65381",
    "data-name": "Path 65381",
    d: "M538.157,239.953a39.61,39.61,0,0,1-38.543,30.507c-11.679,0-20.052-5.86-25.024-15.012l-13.013-23.914c11.57-4.644,18.571-12.658,20.267-24.718,2.2-15.7-6.677-26.83-28.909-26.83H412.876l-11.143,79.3h21.189l3.427-24.34h13.062l12.915,24.624c11.981,22.844,27.979,29.819,47.287,29.819,28.9,0,54.33-19.353,59.264-49.433ZM460.284,208.57c-.88,6.261-6.042,9.99-13.81,9.99H428.648l2.864-20.358h17.562c6.794,0,12.295,2.656,11.21,10.368",
    transform: "translate(85.834 -89.357)",
    fill: "#24226a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65382",
    "data-name": "Path 65382",
    d: "M305.507,259.282h63.5l2.456-17.354H328.189l2.1-14.853h38.729l2.188-15.457H332.481l2.029-14.279h42.7l2.46-17.354H316.74Z",
    transform: "translate(-181.523 -89.359)",
    fill: "#24226a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65383",
    "data-name": "Path 65383",
    d: "M380.957,259.282h63.5l2.46-17.354H403.643l2.1-14.853h38.729l2.192-15.457H407.939l2.021-14.279h42.7l2.456-17.354H392.19Z",
    transform: "translate(28.108 -89.359)",
    fill: "#24226a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65384",
    "data-name": "Path 65384",
    d: "M308.878,209.112a11.035,11.035,0,0,0-10.164,5.69c-.718-3.291-3.034-5.69-7.723-5.69-5.135,0-7.606,2.732-9.306,5.354a43.577,43.577,0,0,0,.465-4.572h-4.855c-.272,2.509-.642,5.237-1.016,7.916L273.384,238.1h4.969l2.071-14.494c.74-5.4,3.461-10.141,8.758-10.141,5.135,0,5.369,4.292,4.87,7.579L291.6,238.1h4.969l2.142-14.993c.869-6.023,3.884-9.642,8.52-9.642,5.248,0,5.536,4.292,5.037,7.636l-2.4,17h4.912l2.479-17.445c1.171-8.082-2.705-11.539-8.388-11.539",
    transform: "translate(-270.773 -8.434)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65385",
    "data-name": "Path 65385",
    d: "M301.366,209.113c-10.376,0-15.692,8.078-15.1,16.829.495,7.413,5.558,12.934,13.84,12.934,11.093,0,15.673-8.362,15.114-16.667-.465-6.967-5.237-13.1-13.852-13.1m-1.1,25.58c-5.025,0-8.577-3.567-8.943-9.027-.431-6.469,3.2-12.435,9.767-12.435,5.69,0,8.607,4.016,8.943,9.034.408,6.072-2.369,12.427-9.767,12.427",
    transform: "translate(-235.111 -8.431)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65386",
    "data-name": "Path 65386",
    d: "M306.15,232.729h-.057c-.8-3.011-3-10.92-6.537-23.411h-5.078l8.294,28.21h5.407l16.224-28.21h-5.467c-8.584,15.216-11.551,20.456-12.786,23.411",
    transform: "translate(-212.163 -7.861)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65387",
    "data-name": "Path 65387",
    d: "M317.342,209.112c-10.542,0-15.658,8.585-15.087,17.056.5,7.579,5.1,12.707,13.213,12.707,8.226,0,11.773-3.956,13.557-8.637h-5.188c-1.727,3.121-4.009,4.515-8.2,4.515-4.859,0-8.037-2.955-8.407-8.475-.03-.446,0-.892-.019-1.168h22.908a15.67,15.67,0,0,0,.223-4.126c-.435-6.408-4.44-11.872-13-11.872m8.112,12.318H307.677c.922-5.184,4.3-8.362,9.488-8.362,5.686,0,8.021,3.514,8.278,7.357.034.5.008.948.011,1.005",
    transform: "translate(-190.678 -8.434)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65388",
    "data-name": "Path 65388",
    d: "M335.75,223.8c-.79-1.95-3.82-5.18-10.281-5.18-9.661,0-15.348,8.248-14.755,17.112.5,7.47,4.931,12.65,12.385,12.65,5.52,0,8.093-1.95,9.892-4.791-.272,1.727-.393,3.174-.45,4.013h4.8c.321-2.675.7-5.35,1.066-8.029l4.855-33.885H338.3Zm-1.281,10.481c-.741,5.464-3.816,9.813-10.164,9.813-5.139,0-8.078-3.518-8.43-8.751-.435-6.525,3.253-12.488,9.93-12.488,6.571,0,9.646,3.846,8.664,11.426",
    transform: "translate(-167.173 -17.941)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65389",
    "data-name": "Path 65389",
    d: "M355.091,230.6c-.54-8.082-6.049-11.981-11.789-11.981-5.909,0-8.611,2.562-10.523,5.294l2.592-18.223H330.4l-4.829,34.278c-.537,3.567-.96,6.238-1.2,7.632h4.859c.219-.892.484-2.675.835-4.852,1.3,2.9,4.3,5.63,10.039,5.63,10.655,0,15.6-8.637,14.989-17.777m-15.333,13.489c-6.291,0-9.246-4.572-8.4-10.814.767-5.853,4.383-10.364,10.512-10.364,5.3,0,7.708,3.786,8,8.188.453,6.8-2.993,12.99-10.119,12.99",
    transform: "translate(-129.117 -17.939)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65390",
    "data-name": "Path 65390",
    d: "M347.913,234.011H347.8c-.627-2.788-3.083-11.483-6.948-24.692h-5.135l9.068,29.925c-2.856,5.131-4.678,6.861-8.263,6.861a18.173,18.173,0,0,1-3.559-.34l-.7,4.406a21.126,21.126,0,0,0,4.341.559c6.514,0,8.8-2.229,14.071-12.541l14.845-28.871h-5.407c-6.729,13.323-10.791,21.9-12.2,24.692",
    transform: "translate(-107.173 -7.859)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65391",
    "data-name": "Path 65391",
    d: "M360.353,234.011h-.113c-.623-2.788-3.083-11.483-6.948-24.692h-5.135l9.068,29.925c-2.856,5.131-4.677,6.861-8.263,6.861a18.172,18.172,0,0,1-3.559-.34l-.7,4.406a21.124,21.124,0,0,0,4.341.559c6.514,0,8.8-2.229,14.067-12.541l14.849-28.871h-5.407c-6.729,13.323-10.791,21.9-12.2,24.692",
    transform: "translate(-72.609 -7.859)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65392",
    "data-name": "Path 65392",
    d: "M368.565,209.113c-10.375,0-15.688,8.078-15.1,16.829.495,7.413,5.558,12.934,13.84,12.934,11.093,0,15.673-8.362,15.114-16.667-.465-6.967-5.237-13.1-13.852-13.1m-1.1,25.58c-5.025,0-8.577-3.567-8.943-9.027-.431-6.469,3.2-12.435,9.767-12.435,5.69,0,8.607,4.016,8.943,9.034.408,6.072-2.373,12.427-9.767,12.427",
    transform: "translate(-48.403 -8.431)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65393",
    "data-name": "Path 65393",
    d: "M385,209.318l-1.734,12.042c-1.262,8.3-4.455,12.65-10.47,12.65-5.244,0-5.857-4.179-5.211-8.581l2.286-16.111H364.9l-2.494,17.169c-1.168,8.139,2.891,11.815,8.962,11.815,6.291,0,8.433-2.618,10.225-5.63a42.1,42.1,0,0,0-.454,4.848h4.92c.223-2.339.6-5.014.982-7.579l2.921-20.623Z",
    transform: "translate(-23.988 -7.861)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65394",
    "data-name": "Path 65394",
    d: "M463.34,175.7l6.238,14.286,13.961-6.933L479.138,198l15.151,3.665L481.3,210.29l9.253,12.548L475.064,221.1l-.975,15.559-10.75-11.29-10.75,11.29-.975-15.559-15.491,1.742,9.253-12.548-12.986-8.622L447.543,198l-4.4-14.951,13.961,6.933Z",
    transform: "translate(171.012 -101.27)",
    fill: "#ea5c47"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17314",
    "data-name": "Rectangle 17314",
    width: 667.261,
    height: 270.813,
    transform: "translate(0)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServier);
export default __webpack_public_path__ + "static/media/servier.67a2f2709c2cfe5e5b477d03e121a51b.svg";
export { ForwardRef as ReactComponent };